export default "__VITE_ASSET__Dvc2vhkR__"